export default function NotFound() {
  return (
    <div className="text-center mt-2 flex-1">
      <h1>
        404 <br /> Pagina Non Trovata
      </h1>
    </div>
  )
}
